/* Custom Theme Scripts go in -> CustTheme-foot.js */

var CustLoadScript = function(url, callback) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    if (script.readyState){
        script.onreadystatechange = function() {
            if (script.readyState == "loaded" || script.readyState == "complete") {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {
        script.onload = function() {
            callback();
        };
    }
    script.src = url;
    document.getElementsByTagName("head")[0].appendChild(script);
};

var CustTheme = (function (my) {
    my.VERSION = '21.8.11.1';
    my.DEBUG = true;
    my.$ = null;
    my.viewport = null;
    my.heightFitGroups = [];

    my.initHead = function() {
        // HTML5BP: Avoid `console` errors in browsers that lack a console.
        (function() {
            var method;
            var noop = function () {};
            var methods = [
                'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
                'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
                'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
                'timeStamp', 'trace', 'warn'
            ];
            var length = methods.length;
            var console = (window.console = window.console || {});

            while (length--) {
                method = methods[length];

                // Only stub undefined methods.
                if (!console[method]) {
                    console[method] = noop;
                }
            }
        }());

        if (my.DEBUG) { console.log('CustTheme v' + my.VERSION + ' DEBUG enabled'); }
    };

    my.getViewport = function() {
        my.viewport = { width : my.$(window).width(), height : my.$(window).height() };
    };

    my.callFunc = function(functionName, args) {
        var fn = window[functionName];
        if (typeof fn === "function") {
            fn.apply(null, args);
        }
    };

    my.getUrlDomain = function(url) {
        var domain = (url.indexOf("://") > -1) ? url.split('/')[2] : url.split('/')[0];
        domain = domain.split(':')[0];
        domain = domain.replace('www.', '');

        return domain;
    };

    my.getUrlSegments = function() {
        var segs = window.location.pathname.split("/");
        segs.shift();

        return segs;
    };

    my.getUrlParameter = function(sParam) {
        var sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : sParameterName[1];
            }
        }
    };

    my.removeParam = function(key, sourceURL) {
        var rtn = sourceURL.split("?")[0],
            param,
            params_arr = [],
            queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
        if (queryString !== "") {
            params_arr = queryString.split("&");
            for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                param = params_arr[i].split("=")[0];
                if (param === key) {
                    params_arr.splice(i, 1);
                }
            }
            rtn = rtn + "?" + params_arr.join("&");
        }
        return rtn;
    };

    my.applyParam = function(key, val, sourceURL) {
        return sourceURL += (sourceURL.match(/\?/) ? '&' : '?') + key + '=' + val;
    };

    my.slugify = function(str, separator) {
        if (typeof(separator) === 'undefined') { separator = '-'; }

        str = str.trim();
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        var from = "åàáãäâèéëêìíïîòóöôùúüûñç·/_,:;";  // jshint ignore:line
        var to = "aaaaaaeeeeiiiioooouuuunc------";

        for (var i = 0, l = from.length; i < l; i++) {
            str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
        }

        return str
            .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
            .replace(/\s+/g, "-") // collapse whitespace and replace by -
            .replace(/-+/g, "-") // collapse dashes
            .replace(/^-+/, "") // trim - from start of text
            .replace(/-+$/, "") // trim - from end of text
            .replace(/-/g, separator);
    };

    my.addHeightFitGroup = function(groupClass) {
        my.heightFitGroups.push(groupClass);
    };

    my.removeHeightFitGroup = function(groupClass) {
        var index = my.heightFitGroups.indexOf(groupClass);
        if (index !== -1)  my.heightFitGroups.splice(index, 1);
    };

    my.updateHeightFitGroups = function() {
        var self = this;  // jshint ignore:line
        var $ = self.$;  // jshint ignore:line

        var tallestFunc = function(el, tallest) {
            var $el = $(el);
            $el.css('height', 'auto');
            var height = parseInt($el.outerHeight());
            tallest = height > tallest ? height : tallest;

            return tallest;
        };

        for (var gi = 0, len = my.heightFitGroups.length; gi < len; gi++) {
            var fitClass = my.heightFitGroups[gi];
            var $elements = $('.' + fitClass);

            var tallest = 0;
            $elements.each(function() {  // jshint ignore:line
                tallest = tallestFunc(this, tallest);
            });

            $elements.css('height', tallest + 'px');
        }
    };

    return my;
}(CustTheme || {}));

CustTheme.initHead();
